import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import i18n from "config/i18n"
import { API } from "redux/api"
import { CONSENT_STATUS_DONE } from "config"
import { ConsentFormValues } from "types"

export const fetchConsent = createAsyncThunk("consent/fetch", async () => {
  const response = await API.get("/consent")
  return response.data
})

export const createConsent = createAsyncThunk(
  "consent/create",
  async (values: ConsentFormValues) => {
    const response = await API.post("/consent", values)
    return response.data
  },
)

export const makeConsent = (values: ConsentFormValues) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise<{
      consent_id: string
    }>((resolve, reject) => {
      return dispatch(createConsent(values))
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.subscription.consent.unavailable"))
            }

            const { consent } = payload

            if (consent) {
              const { id, status } = consent

              if (status === CONSENT_STATUS_DONE) {
                return resolve(id)
              } else {
                return reject(i18n.t("notice.subscription.consent.failure"))
              }
            }
          },
          () => {
            reject(i18n.t("notice.subscription.consent.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}
